// import * as actions from '../actions/actions';

const initialState = {
  help: false,
  chartElements: ['help-0', 'help-1', 'help-2'],
  mapElements: ['.esri-layer-list', '.esri-zoom', '.esri-basemap-toggle', '#help'],
  porElements: ['help-0', 'help-1', 'help-2', 'help-3'],
  currentIndex: 0, // set back to 0 anytime the help dismounts
};

const auth = ( state = initialState, action ) => {
	// must return the same state or an updated version of the state
  const actionLookup = {
    'START_HELP': () => ({...state, help: true}),
    'END_HELP': () => ({...state, help: false, currentIndex: 0}),
    'ADVANCE_HELP': () => ({...state, currentIndex: state.currentIndex + 1}),
    'BACK_HELP': () => ({...state, currentIndex: state.currentIndex - 1})
  };
  return actionLookup[action.type] ? actionLookup[action.type](state, action) : {...state}; // if the action type exists, execute action, otherwise returns default state
};

export default auth;


// WEBPACK FOOTER //
// ./src/store/reducers/help.js